import React, { useState } from 'react';
import { Calendar, MapPin, Clock, Users, MessageSquare, Award, ArrowRight } from 'lucide-react';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
export const WarriEvent2025 = () => {
  const [activeTab, setActiveTab] = useState('details');
  const eventQuotes = ['Network and Grow', "Don't only use bridges, build them.", "Opportunities don't just knock—they're introduced through people.", 'Give, and Give; it comes back to you in greater measure.'];
  return <div className="pt-20 bg-white" data-id="element-4955">
      {/* Hero Section */}
      <section className="relative py-16 border-b border-gray-300" data-id="element-4956">
        <div className="absolute inset-0 z-0" data-id="element-4957">
          <div className="w-full h-full bg-gray-200 border-2 border-dashed border-gray-400" data-id="element-4958"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-4959">
          <div className="max-w-3xl mx-auto text-center" data-id="element-4960">
            <div className="inline-block bg-white border border-gray-300 px-4 py-1 rounded-md text-sm font-bold mb-6" data-id="element-4961">
              UPCOMING EVENT
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" data-id="element-4962">
              Networking Salon: Warri Edition 2025
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-4963">
              Connect with ambitious professionals in Warri and build meaningful
              relationships that unlock new opportunities.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-4964">
              <Button className="border-2 border-gray-800" data-id="element-4965">Register Now</Button>
              <Button variant="outline" className="border-2 border-gray-400" data-id="element-4966">
                Learn More
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Event Details Section */}
      <section className="py-12 border-b border-gray-300" data-id="element-4967">
        <div className="container mx-auto px-4" data-id="element-4968">
          <div className="max-w-4xl mx-auto" data-id="element-4969">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-4970">
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-4971">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-4972">
                  <Calendar size={24} className="text-gray-700" data-id="element-4973" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-4974">Date</h3>
                <p className="text-gray-600" data-id="element-4975">August 30, 2025</p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-4976">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-4977">
                  <MapPin size={24} className="text-gray-700" data-id="element-4978" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-4979">Venue</h3>
                <p className="text-gray-600" data-id="element-4980">Deluxe á la Carte Restaurant</p>
                <p className="text-gray-600" data-id="element-4981">Warri, Nigeria</p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-4982">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-4983">
                  <Clock size={24} className="text-gray-700" data-id="element-4984" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-4985">Time</h3>
                <p className="text-gray-600" data-id="element-4986">4:00 PM - 7:00 PM</p>
              </div>
            </div>
            <div className="border-2 border-gray-300 rounded-lg overflow-hidden mb-8" data-id="element-4987">
              <div className="flex border-b border-gray-300" data-id="element-4988">
                <button className={`px-6 py-3 font-medium ${activeTab === 'details' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('details')} data-id="element-4989">
                  Event Details
                </button>
                <button className={`px-6 py-3 font-medium ${activeTab === 'agenda' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('agenda')} data-id="element-4990">
                  Agenda
                </button>
                <button className={`px-6 py-3 font-medium ${activeTab === 'speakers' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('speakers')} data-id="element-4991">
                  Speakers
                </button>
              </div>
              <div className="p-6" data-id="element-4992">
                {activeTab === 'details' && <div data-id="element-4993">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4994">
                      About This Event
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-4995">
                      Join us for an evening of meaningful connections,
                      inspiring conversations, and opportunities in Warri. The
                      Networking Salon brings together ambitious professionals,
                      entrepreneurs, and changemakers to build relationships
                      that matter.
                    </p>
                    <p className="text-gray-600 mb-4" data-id="element-4996">
                      This special edition will focus on creating strategic
                      connections among Warri's growing professional community,
                      with structured networking activities, curated
                      discussions, and opportunities to share ideas.
                    </p>
                    <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4997">
                      <div className="border border-gray-300 rounded-lg p-4 flex items-start" data-id="element-4998">
                        <Users size={20} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-4999" />
                        <div data-id="element-5000">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-5001">
                            Who Should Attend
                          </h4>
                          <p className="text-gray-600" data-id="element-5002">
                            Professionals, entrepreneurs, creatives, and
                            change-makers ages 18-45
                          </p>
                        </div>
                      </div>
                      <div className="border border-gray-300 rounded-lg p-4 flex items-start" data-id="element-5003">
                        <Award size={20} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-5004" />
                        <div data-id="element-5005">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-5006">
                            What You'll Gain
                          </h4>
                          <p className="text-gray-600" data-id="element-5007">
                            Strategic connections, visibility, and access to
                            opportunities
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>}
                {activeTab === 'agenda' && <div data-id="element-5008">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5009">
                      Event Agenda
                    </h3>
                    <div className="space-y-6" data-id="element-5010">
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-5011">
                        <div className="flex items-center mb-2" data-id="element-5012">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-5013">
                            <span className="text-gray-700 font-bold" data-id="element-5014">1</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-5015">
                            4:00 PM - 4:30 PM: Registration & Welcome
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-5016">
                          Check-in, receive your name tag, and enjoy welcome
                          refreshments
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-5017">
                        <div className="flex items-center mb-2" data-id="element-5018">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-5019">
                            <span className="text-gray-700 font-bold" data-id="element-5020">2</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-5021">
                            4:30 PM - 5:00 PM: Keynote Session
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-5022">
                          Opening remarks and keynote presentation on building
                          powerful networks
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-5023">
                        <div className="flex items-center mb-2" data-id="element-5024">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-5025">
                            <span className="text-gray-700 font-bold" data-id="element-5026">3</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-5027">
                            5:00 PM - 6:00 PM: Structured Networking
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-5028">
                          Guided networking activities designed to create
                          meaningful connections
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-5029">
                        <div className="flex items-center mb-2" data-id="element-5030">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-5031">
                            <span className="text-gray-700 font-bold" data-id="element-5032">4</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-5033">
                            6:00 PM - 6:45 PM: Panel Discussion
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-5034">
                          Industry leaders share insights on opportunities in
                          Warri and beyond
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-5035">
                        <div className="flex items-center mb-2" data-id="element-5036">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-5037">
                            <span className="text-gray-700 font-bold" data-id="element-5038">5</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-5039">
                            6:45 PM - 7:00 PM: Closing & Next Steps
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-5040">
                          Wrap-up, next steps, and information about future
                          events
                        </p>
                      </div>
                    </div>
                  </div>}
                {activeTab === 'speakers' && <div data-id="element-5041">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5042">
                      Featured Speakers
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5043">
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-5044">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-5045"></div>
                        <div data-id="element-5046">
                          <h4 className="font-bold text-gray-800" data-id="element-5047">
                            Andrew Igbineweka
                          </h4>
                          <p className="text-gray-600" data-id="element-5048">
                            Founder, The Networking Salon
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-5049">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-5050"></div>
                        <div data-id="element-5051">
                          <h4 className="font-bold text-gray-800" data-id="element-5052">
                            Local Lead
                          </h4>
                          <p className="text-gray-600" data-id="element-5053">Warri City Ambassador</p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-5054">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-5055"></div>
                        <div data-id="element-5056">
                          <h4 className="font-bold text-gray-800" data-id="element-5057">
                            Guest Speaker
                          </h4>
                          <p className="text-gray-600" data-id="element-5058">Industry Expert</p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-5059">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-5060"></div>
                        <div data-id="element-5061">
                          <h4 className="font-bold text-gray-800" data-id="element-5062">
                            Panel Moderator
                          </h4>
                          <p className="text-gray-600" data-id="element-5063">Community Leader</p>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Event Highlights */}
      <section className="py-12 border-b border-gray-300" data-id="element-5064">
        <div className="container mx-auto px-4" data-id="element-5065">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-8" data-id="element-5066">
            Event Highlights
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-5067">
            <div className="relative aspect-[4/3] border-2 border-dashed border-gray-400 rounded-lg overflow-hidden" data-id="element-5068">
              <div className="absolute inset-0 bg-gray-100 flex items-center justify-center" data-id="element-5069">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-5070">
                  <MessageSquare size={32} className="text-gray-500" data-id="element-5071" />
                </div>
              </div>
            </div>
            <div data-id="element-5072">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5073">
                Inspiring Conversations
              </h3>
              <div className="space-y-4" data-id="element-5074">
                {eventQuotes.map((quote, index) => <div key={index} className="border-l-2 border-gray-400 pl-4" data-id="element-5075">
                    <p className="text-gray-700 font-medium" data-id="element-5076">{quote}</p>
                  </div>)}
              </div>
              <div className="mt-6" data-id="element-5077">
                <p className="text-gray-600" data-id="element-5078">
                  Join us at Deluxe á la Carte Restaurant in Warri for an
                  evening of meaningful networking and inspiration. Connect with
                  like-minded professionals and discover new opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Registration Section */}
      <section className="py-12 border-b border-gray-300 bg-gray-50" data-id="element-5079">
        <div className="container mx-auto px-4" data-id="element-5080">
          <div className="max-w-3xl mx-auto text-center" data-id="element-5081">
            <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-5082">
              Secure Your Spot
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-5083">
              Limited seats available. Register now to join The Networking Salon
              Warri Edition.
            </p>
            <div className="border-2 border-gray-300 rounded-lg p-6 bg-white mb-8" data-id="element-5084">
              <div className="flex justify-center mb-6" data-id="element-5085">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-5086">
                  <Award size={32} className="text-gray-700" data-id="element-5087" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-5088">
                Event Registration
              </h3>
              <div className="text-center mb-6" data-id="element-5089">
                <p className="text-3xl font-bold text-gray-800" data-id="element-5090">₦5,000</p>
                <p className="text-gray-600" data-id="element-5091">per person</p>
              </div>
              <ul className="space-y-3 mb-8 text-left max-w-md mx-auto" data-id="element-5092">
                <li className="flex items-start" data-id="element-5093">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-5094">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-5095"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-5096">
                    Full access to the networking event
                  </span>
                </li>
                <li className="flex items-start" data-id="element-5097">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-5098">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-5099"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-5100">Refreshments and dinner</span>
                </li>
                <li className="flex items-start" data-id="element-5101">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-5102">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-5103"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-5104">
                    Professional networking materials
                  </span>
                </li>
                <li className="flex items-start" data-id="element-5105">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-5106">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-5107"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-5108">
                    Access to post-event connections
                  </span>
                </li>
              </ul>
              <Button className="w-full border-2 border-gray-800" data-id="element-5109">
                Register Now
              </Button>
            </div>
            <p className="text-gray-600" data-id="element-5110">
              Inner Circle members receive a special discount.
              <Link to="/membership" className="underline ml-1" data-id="element-5111">
                Learn more about membership
              </Link>
            </p>
          </div>
        </div>
      </section>
      {/* Location Map */}
      <section className="py-12" data-id="element-5112">
        <div className="container mx-auto px-4" data-id="element-5113">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-8" data-id="element-5114">
            Event Location
          </h2>
          <div className="max-w-4xl mx-auto" data-id="element-5115">
            <div className="aspect-[16/9] border-2 border-gray-300 rounded-lg overflow-hidden mb-6" data-id="element-5116">
              <div className="w-full h-full bg-gray-200 flex items-center justify-center" data-id="element-5117">
                <div className="text-center" data-id="element-5118">
                  <MapPin size={48} className="text-gray-400 mx-auto mb-2" data-id="element-5119" />
                  <p className="text-gray-600" data-id="element-5120">
                    Map of Deluxe á la Carte Restaurant, Warri
                  </p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5121">
              <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-5122">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5123">
                  Venue Details
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-5124">
                  <strong data-id="element-5125">Deluxe á la Carte Restaurant</strong>
                  <br data-id="element-5126" />
                  Warri, Delta State, Nigeria
                </p>
                <p className="text-gray-600" data-id="element-5127">
                  A premium dining venue with excellent facilities for
                  networking events. The restaurant offers a comfortable
                  atmosphere conducive to meaningful conversations and
                  connections.
                </p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-5128">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-5129">
                  Contact Information
                </h3>
                <div className="space-y-4" data-id="element-5130">
                  <p className="text-gray-600" data-id="element-5131">
                    <strong data-id="element-5132">Event Coordinator:</strong>
                    <br data-id="element-5133" />
                    The Networking Salon Team
                    <br data-id="element-5134" />
                    info@thenetworkingsalon.live
                  </p>
                  <p className="text-gray-600" data-id="element-5135">
                    <strong data-id="element-5136">Local Lead:</strong>
                    <br data-id="element-5137" />
                    Warri City Ambassador
                    <br data-id="element-5138" />
                    warri@thenetworkingsalon.live
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-16 bg-gray-50" data-id="element-5139">
        <div className="container mx-auto px-4 text-center" data-id="element-5140">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 max-w-2xl mx-auto" data-id="element-5141">
            Join Us in Warri to Build Connections That Matter
          </h2>
          <Button className="border-2 border-gray-800" data-id="element-5142">
            Register for the Event
            <ArrowRight size={16} className="ml-2" data-id="element-5143" />
          </Button>
        </div>
      </section>
    </div>;
};